import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-getting-started',
	templateUrl:'./GettingStartedPage.html',
	styles: [],
	styleUrls:['./GettingStartedPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		WaTagDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GettingStartedPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_9 = `\`\`\`java
@NgApp(value = "my-app", bootComponent = MyHomePage.class)
public class MyApplication extends NGApplication<MyApplication> {
    public MyApplication() {
        getOptions().setTitle("My App");
    }
}
\`\`\``;
	mdContent_10 = `\`\`\`java
public class MyHomePage extends Page<MyHomePage> {
    public MyHomePage() {
        add("Hello World");
    }

    public static void main(String[] args) {
        System.setProperty("HTTP_ENABLED", "true");
        IGuiceContext.instance().inject();
    }
}
\`\`\``;
	mdContent_11 = `\`\`\`java
<plugin>
    <groupId>com.jwebmp.plugins</groupId>
    <artifactId>angular-maven-plugin</artifactId>
    <version>\${jwebmp.version}</version>
    <executions>
        <execution>
            <id>build-angular</id>
            <phase>install</phase>
            <goals>
                <goal>build</goal>
            </goals>
        </execution>
    </executions>
</plugin>
\`\`\``;
	mdContent_12 = `\`\`\`groovy
plugins {
    id("com.jwebmp.angular") version jwebmpVersion
}

jwebmpAngular {
    // runs during the build task
}
\`\`\``;
	mdContent_13 = `\`\`\`java
public final class Boot {
    public static void main(String[] args) {
        System.setProperty("HTTP_ENABLED", "true");
        System.setProperty("HTTP_PORT", "8080");
        IGuiceContext.instance().inject();
    }
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
